const config = {
    urlApi: process.env.REACT_APP_URL_API,
    urlWeb: process.env.REACT_APP_URL_WEB
}

export default config;